<template>
  <div>
    <b-row class="mt-4">
      <b-col>
        <h4 class="font-weight-bold">Reservation Detail per 1000 Member ID</h4>
      </b-col>
      <b-col md="2" class="my-1" align="left">
        <b-form-group label-cols-sm="6" label="Show" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1" align="right">
        <b-col class="pr-0">
            <b-button
              @click="filterShow = !filterShow"
              class="bg-white text-primary border-secondary"
            >
              <img src="@/assets/filter.svg" alt /> Filter Data
            </b-button>
          </b-col>
      </b-col>
    </b-row>
    <br />
    <!-- <section v-if="table_error">
      <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section> -->
    <b-table
      responsive
      show-empty
      hover
      ref="reservationLogTable"
      :items="getDetailReservationLog"
      :fields="types"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      head-variant="light"
      class="bg-white"
    >
      <div slot="table-busy" class="text-center text-primary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
      <template v-slot:cell(created_at)="{ item }">
        <p class="mb-0">{{item.created_at | DateTime}}</p>
      </template>
      <template v-slot:cell(remarks)="{ item }">
        <p class="mb-0 text-danger font-weight-bold" v-if="item.status == 'failed'">{{item.remarks}}</p>
        <p class="mb-0 font-weight-bold" v-else>{{item.remarks}}</p>
      </template>
      <template v-slot:cell(no)="{ item }">
        <div v-if="item.member_codes.length == 1000">
          <p class="mb-0">{{((item.no-1)*1000)+1 }} - {{ parseInt(item.no) * 1000 }}</p>
        </div>
        <div v-else-if="item.member_codes.length == 0">
          <p class="mb-0">{{((item.no-1)*1000)+1 }} - {{ ((item.no-1)*1000)+1 }}</p>
        </div>
        <div v-else>
          <p class="mb-0">{{((item.no-1)*1000)+1 }} - {{((item.no-1)*1000)+ item.member_codes.length }}</p>
        </div>
      </template>
      <template v-slot:cell(status)="{ item }">
        <p class="mb-0 text-success font-weight-bold" v-if="item.status == 'on_progress'">On Progress</p>
        <p class="mb-0 font-weight-bold" style="color:#000" v-else-if="item.status == 'success'">Success</p>
        <p class="mb-0 text-danger font-weight-bold" v-else-if="item.status == 'failed'">Failed</p>
      </template>
      <template v-slot:cell(action)="{item}">
        <b-row>
          <b-link v-b-tooltip.hover title="Detail Member" class="text-dark" @click="showModalFormUniversalVoucher(item.member_codes)">
            <img class="mr-2" src="@/assets/ic-view-detail.svg" alt />
          </b-link>
          <b-link v-b-tooltip.hover title="Restart" class="text-dark ml-4" @click="resetReserveLog(item.batch_no,item.no)">
            <i class="fas fa-sync"></i>
          </b-link>
        </b-row>
      </template>
    </b-table>
    <b-row class="mx-auto">
      <b-col md="4" align="left" class="mx-auto px-0">
        <div v-if="totalRows == 0 || totalRows == null">
          Showing 0 Records
        </div>
        <div v-else>
          Showing {{ fromPage[currentPage - 1] }} to
          {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
        </div>
      </b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    
    <b-modal
      v-model="modalFormVoucherUniversalShow"
      size="xl"
      hide-header
      hide-footer
      no-close-on-esc
      >
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">Reservation Detail per Member ID</h4>
          </b-col>
          <b-col>
            <b-form-group label-cols-sm="6" label="Show" class="mb-0">
              <b-form-select v-model="perPage2">
                <option
                          v-for="page in pageOptions2" :key="page.val"
                          :value="page.val"
                        >
                        {{page.name}}
                        </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        
        <b-table
              responsive
              show-empty
              hover
              ref="reservationLogTable"
              :items="memberLog"
              :fields="typesMember"
              :current-page="currentPage2"
              :per-page="perPage2"
              @filtered="onFiltered2"
              head-variant="light"
              class="bg-white"
            ></b-table>
            <b-pagination
            align="right"
            v-model="currentPage2"
            :total-rows="memberLog.length"
            :per-page="perPage2"
            class="my-0"
          ></b-pagination>
      </div>
    </b-modal>
    <b-modal
      v-model="filterShow"
      id="modal-prevent-closing"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      size="md"
    >
      <!-- <h4>Kirim ke Email</h4> -->
      <br />
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Status"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-form-select
                  v-model="status"
                  name="status"
                  data-vv-as="status"
                  class="mb-3"
                >
                  <template v-slot:first>
                    <option value disabled>-- Status --</option>
                  </template>
                  <option value="success">Success</option>
                  <option value="failed">Failed</option>
                  <option value="on_progress">On Progress</option>
                </b-form-select>

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("trensaction_status") }}
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="Sort By"
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-form-select
                  v-model="sory_by"
                  name="sory_by"
                  data-vv-as="Sort By"
                  class="mb-3"
                >
                  <template v-slot:first>
                    <option value disabled>-- Sort By --</option>
                  </template>
                  <option value="created_at_asc">Date Time Newest - Oldest</option>
                  <option value="created_at_dsc">Date Time Oldest - Newest</option>
                  <option value="status">Status</option>
                </b-form-select>

                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("locker_order_type") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col md="12">
          <b-row>
            <b-col>
              <label class="font-weight-bold">
                Create Period
              </label>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label=""
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="From"
                      v-model="created_date_from"
                      :format="customFormatter"
                      :disabledDates="element2"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetCreatedDateFrom"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label=""
                class="font-weight-bold"
                label-for="input-1"
              >
                <b-row class="m-0 pr-4">
                  <b-col
                    class="pr-0 pt-1 form-control img-calender-select border-right-0"
                    md="2"
                  >
                    <img
                      src="@/assets/ic-calendar-copy-30.svg"
                      width="25px"
                      alt
                      class
                    />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="To"
                      v-model="created_date_to"
                      :format="customFormatter"
                      :disabledDates="element"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link
                            @click="resetCreatedDateTo"
                            style="text-decoration: none"
                          >
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
                <br />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row> -->

      <br />
      <b-row>
        <b-col offset-md="8" md="2">
          <b-button
            variant="light"
            @click="ResetFilterData()"
            class="text-primary border-secondary"
            block
            size="lg"
            >Reset</b-button
          >
        </b-col>
        <b-col md="2" align-self="right" class="text-right">
          <b-button variant="primary" @click="FilterData()" block size="lg"
            >Apply</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  props:["batch_no"],
  components: {
    Datepicker
  },
  data() {
    return {
      table_error: false,
      loading_universal_voucher: false,
      loading_form_universal_voucher: false,
      modalFormVoucherUniversalShow: false,
      memberLog: [],
      universal_voucher: {
        id: "",
        voucher_name: "",
        membership: [],
      },
      universal_vouchers: [],
      types: [
        {
          key: "no",
          label: "Data Row",
          sortable: false,
          class: "text-left w-20"
        },
        {
          key: "status",
          label: "Status",
          sortable: false,
          class: "text-left w-20"
        },
        {
          key: "remarks",
          label: "Remarks",
          sortable: false,
          class: "text-left w-30"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      typesMember: [
        {
          key: "member_code",
          label: "Member ID",
          sortable: false,
          class: "text-left w-20"
        },
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      currentPage2: 1,
      perPage2: 10,
      pageOptions: [10, 25, 50, 100],
      pageOptions2: [
        {
        val:10,
        name:10
        },
        {
        val:25,
        name:25
        },
        {
        val:50,
        name:50
        },
        {
        val:10000,
        name:"See All"
        },
        ],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      filterShow: false,
      sory_by: "created_at_asc",
      status: "",
      created_date_from: new Date(new Date().setDate(new Date().getDate() - 7)),
      created_date_to: new Date(Date.now()),
      universal_voucher_membership: [
        {text: "Gold", value: "gold"},
        {text: "Silver", value: "silver"},
        {text: "Gold2.0", value: "gold2.0"},
        {text: "Silver2.0", value: "silver2.0"},
        {text: "Non Member", value: "non_member"},
      ]
    }
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
  },
  computed: {
    element() {
      var date = this.created_date_from ? this.created_date_from : null;
      var disabledDates = {
        to: new Date(date - 8640000),
        from: new Date(Date.now() + 8640000),
      };
      return disabledDates;
    },
    element2() {
      var date = this.created_date_to ? this.created_date_to : Date.now();
      var disabledDates = {
        from: new Date(date + 8640000),
      };
      return disabledDates;
    },
  },
  methods: {
    resetCreatedDateFrom() {
      this.created_date_from = "";
    },
    resetCreatedDateTo() {
      this.created_date_to = "";
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    ResetFilterData() {
      this.status = "";
      this.sort_by = "";
      this.created_date_from = new Date(new Date().setDate(new Date().getDate() - 7));
      this.created_date_to = new Date(Date.now());
      this.$refs.reservationLogTable.refresh();
      this.filterShow = false;
    },
    FilterData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$refs.reservationLogTable.refresh();
          this.filterShow = false;
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: "Invalid form input",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    getDetailReservationLog(ctx, callback) {
      this.loading_universal_voucher = true;
      const vm = this;
      const formData = new FormData();
      var sort_direction, sortBy
      if(this.sory_by === 'created_at_asc'){
        sort_direction = true
        sortBy = "created_at"
      } else if(this.sory_by === 'created_at_dsc'){
        sort_direction = false
        sortBy = "created_at"
      } else {
        sort_direction = true
        sortBy = "status"
      }
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", sortBy);
      formData.append("app_name", process.env.VUE_APP_NAME_PAXELMARKET);
      formData.append("batch_no", this.batch_no);
      formData.append("is_sort_asc", sort_direction);
      formData.append("status", this.status);
      this.$store
        .dispatch("ReserveModule/getReserveLogDetailWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.universal_vouchers = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_universal_voucher = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get universal voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_universal_voucher = false;
          callback([]);
        });
      return null;
    },
    resetReserveLog(batch_no,no) {
      var payload = {
        batch_no:batch_no,
        no:no
      }
      this.$swal({
        text: `Are you sure want to reset reservation log?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Reset",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ReserveModule/resetReservationLog", payload)
            .then((response) => {
              this.$swal("Reset!", "Your data has been reset.", "success");
              console.log(response);
              this.$refs.reservationLogTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to reset",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    onFiltered2(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage2 = 1;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showModalFormUniversalVoucher(data) {
      data.forEach(item => 
      this.memberLog.push({
        member_code: item
      }) 
      );
      this.modalFormVoucherUniversalShow = !this.modalFormVoucherUniversalShow;
    },
  }
};
</script>